import styled from 'styled-components';
import { Col, Typography } from "antd";

const { Title } = Typography;

export const Styled = styled.div`
  margin-bottom: 24px;

  .label-col {
    display: flex;

    input {
      background-color: #40a9ff05;
    }

    .ant-row.ant-form-item {
      width: 100%;
      margin-top: 0 !important;
    }

    @media only screen and (width >= 576px) {
      .ant-row.ant-form-item {
        margin-right: 8px !important;
      }

      input {
        text-align: right;
      }
    }
  }

  .ant-checkbox-group label {
    height: 32px;
  }

  .desc-col {
    @media only screen and (width >= 767px) {
      padding-left: 8px;
    }

    @media only screen and (width <= 767px) {
      height: 8px;
      text-align: right;
    }
  }

  .first-text-area .ant-row:first-child {
    margin-top: 0 !important;
  }

  .delete-button {
    z-index: 1;
  }

  .radio-button {
    @media only screen and (width <= 767px) {
        margin-top: -36px;
    }
  }
`;

// Styles for each Address Form Item Group
export const StyledAddressGroupDiv = styled.div`
  /* margin-bottom: 24px; */

  .label-col {
    display: flex;
  
  .bold {
    font-weight: 500;
  }

    .ant-form-item {
      width: 100%;
    }
  }

  /* 
  @media only screen and (width >= 576px) { // used in old component
    .ant-form-item {
      margin-right: 8px!important;
    }

    input {
      text-align: right;
    }
  } */

  .ant-checkbox-wrapper, .ant-checkbox-group label { // ant-checkbox-group is for old component
    height: 32px;
    padding: 4px 0;
  }

  /* .desc-col { // used in old component
    @media only screen and (width >= 767px) {
      padding-left: 8px;
    }

    @media only screen and (width <= 767px) {
      height: 8px;
      text-align: right;
    }
  } */

  /* .first-text-area .ant-row:first-child { // used in old component
    margin-top: 0!important;
  } */


  .delete-button-col {
    .delete-button {
      top: 26.5px
    }
  }

  @media only screen and (max-width: 575px) {
    .delete-button-col {
      height: 8px;
      text-align: right;
    }

    .delete-button {
      position: relative;
      top: -30px !important;
    }
  }
`;

export const StyledAddAddressCol = styled(Col)`
  padding-top: 24px;
  display: flex;
  justify-content: end;
`;

// Page Title
export const StyledPageTitle = styled(Title)`
  display: flex;
  justify-content: center;
  align-items: center;

  /* the back button */
  .anticon-arrow-left {
    margin-right: 12px;
    font-size: 16px;
  }
`;

// The floating save button row at the bottom
export const StyledSubmitFooterDiv = styled.div`
  position: sticky;
  bottom: -1px; 
  z-index: 10; 
  background: white;
  border-block-start: 1px solid rgba(5, 5, 5, 0.06);
  margin-top: 24px;
  padding-bottom: 20px;

  .transaction-button-row { /* the Save button */
    margin-top: 20px;
  }

  &.submit-footer-div {
    opacity: 0.95;
  }

  &.submit-footer-div:hover{
    opacity: 1;
    transition: 0.3s;
  }
`;
